export const DraggableItemTypes = {
  TILE: 'Tile',
}
